import { render, staticRenderFns } from "./classCata.vue?vue&type=template&id=3c7bb486&scoped=true&"
import script from "./classCata.vue?vue&type=script&lang=js&"
export * from "./classCata.vue?vue&type=script&lang=js&"
import style0 from "./classCata.vue?vue&type=style&index=0&id=3c7bb486&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c7bb486",
  null
  
)

export default component.exports